<template>
  <div class="multiple-choicess">
  
    <div class="subject-content">
      <div class="subject-title">
        <span class="subject-title-content" v-html="name+index+subjectInfo.subjectName" />
        <span class="subject-title-content"
          v-if="subjectInfo.score !== undefined && subjectInfo.score !== 0">&nbsp;({{subjectInfo.score}})分</span>
      </div>
  
      <ul class="subject-options" v-for="option in options" :key="option.id">
  
        <li class="subject-option">
          <input class="toggle" type="checkbox" :checked="isChecked(option.optionName)" :id="'option' + option.id"
            @change="toggleOption($event, option)">
          <label :for="'option' + option.id">
            <span class="subject-option-prefix">{{ option.optionName }}&nbsp;</span>
            <span v-html="option.optionContent" class="subject-option-prefix" />
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { isNotEmpty } from '@/utils/util'
export default {
  name: 'MultipleChoices',
  data() {
    return {
      subjectCount: 0,
      subjectInfo: {
        subjectName: '',
        score: 0
      },
      options: [],
      userAnswer: [],
      index: '',
      name: "<span class='subject-type-blue'> (多选题)</span>"
    }
  },
  watch: {

  },
  methods: {
    getAnswer() {
      return this.userAnswer.join(',')
    },
    setAnswer(answer) {
      if (isNotEmpty(answer)) {
        this.userAnswer = answer.split(',')
      }
    },
    setSubjectInfo(subject, subjectCount, index) {
      this.userAnswer = []; // 重置用户答案
      this.subjectCount = subjectCount
      this.subjectInfo = subject
      console.log(subject, 'ddddddddddddddddddddd')
      if (Object.prototype.hasOwnProperty.call(subject, "options")) {
        this.options = subject.options
        console.log(this.options, 'options')
      }
      if (Object.prototype.hasOwnProperty.call(subject, "answer")) {
        this.setAnswer(subject.answer.answer)
      }
      this.index = index + '、'
    },
    getSubjectInfo() {
      this.subjectInfo.options = this.options
      return this.subjectInfo
    },
    // 选中选项
    toggleOption($event, option) {
      if ($event.target.checked) {
        if (!this.userAnswer.includes(option.optionName)) {
          this.userAnswer.push(option.optionName)
        }
      } else {
        this.userAnswer.splice(this.userAnswer.findIndex(item => item === option.optionName), 1)
      }
    },
    isChecked(optionName) {
      return this.userAnswer.includes(optionName)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/subject.scss";

/* 多选题专用方形选择框样式 */
.multiple-choicess .subject-options li {
  .toggle+label {
    background: none !important;
    /* 移除圆形背景图 */
  }

  .toggle+label::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border: 1px solid #8a8a8a;
    border-radius: 4px;
    /* 轻微圆角更美观 */
    background-color: white;
  }

  .toggle:checked+label::before {
    background-color: #2aa515;
    /* 选中填充色 */
    border-color: #2aa515;
  }

  .toggle:checked+label::after {
    content: '';
    position: absolute;
    left: 5px;
    top: 50%;
    width: 10px;
    height: 5px;
    border: solid white;
    border-width: 0 0 2px 2px;
    transform: translateY(-60%) rotate(-45deg);
  }
}
</style>
